<template>
  <div>
    <!--      个人 -->
    <div class="first_plate">
      <div class="user_info">
        <img
          v-if="accountInfoVO.userType === 1"
          class="user_photo"
          :src="loginUser && loginUser.imgPath && !isInDingTalk ? fileOperShow(loginUser.imgPath) : ''"
          onerror="this.src='/images/web/login_enterprise_icon.png'"
          alt
        />
        <img
          v-else
          class="user_photo"
          :src="loginUser && loginUser.imgPath && !isInDingTalk  ? fileOperShow(loginUser.imgPath) : ''"
          onerror="this.src='/images/web/login_user_icon.png'"
          alt
        />
        <div class="user_msg">
          <p class="name">{{dingInfo ? dingInfo.dingTalkCorpName : "&nbsp;"}}</p>
          <div class="not_real_name">
            <p class="not_real_name_btn">
              <img class="img" src="../../../static/images/home/no_real_name.png" alt />
              未实名
              <span>去认证</span>
            </p>
          </div>
        </div>
      </div>
      <div class="integral">
        <div class="intergral_text">
          套餐剩余
          <span class="span">10 份合同</span>
        </div>
        <!-- <div class="intergral_text">
          已开通套餐项
          <span class="span">4</span>
        </div> -->
      </div>
      <div class="recharge_btn_box">
        <div class="recharge_btn">
          <i class="el-icon-setting recharge_icon" style="vertical-align: text-bottom"></i>
          控制台
        </div>
        <!-- 【tabindex】 【hidefocus】 为了让blur事件生效-->
        <div class="recharge_btn" tabindex="0" :hidefocus="true">
          <i class="el-icon-coin recharge_icon"></i>
          去充值
        </div>
        <!-- 账号身份列表 -->
        <div v-if="!isInDingTalk && showChangeAccount" class="change-account-sty">
          <change-account
            @showExpandIcon="()=>{}"
            @justCall="pointCall"
            :justSwitching="true"
            :users="consoleUsers"
            :lineHeight="59"
          />
        </div>
      </div>
    </div>
    <!--    产品公告-->
    <div class="product_notice">
      <div :class="['assets_system', {'not_dingding': !isInDingTalk}]">
        <img class="imgs" src="../../../static/images/web/home/dingding_sys_img.png" alt />
      </div>
      <div :class="['notice_content',  {'big_ul_bottom': noticeLengthCom}]">
        <ul class="notice_list">
          <li
            v-for="(item, index) in ddNoticList"
            :key="index"
            :class="['notice_li', {'big_top': noticeLengthCom, 'ding_top': isInDingTalk}]"
          >
            <div class="inline_block">
              <img class="question_icon" src="../../../static/images/home/question.png" alt />
              <span>{{item.title}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="advertisement_box">
      <h3>君子签优惠活动火热进行中！</h3>
      <h4>若您想了解具体政策，欢迎随时联系客服咨询详情。</h4>
      <!-- <el-carousel
        trigger="click"
        arrow="never"
        :autoplay="bannerImgList.length > 1"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in bannerImgList" :key="index">
          <div class="banner-style" @click="bannerJump(item.redirectsAddress )">
            <img class="img" :src="fileOperShow(item.ifileOperVO)" alt />
          </div>
        </el-carousel-item>
      </el-carousel>-->
    </div>
  </div>
</template>

<script>
import { isInDingTalk } from "../../../assets/js/utils/ding-env";
import { fileOperShow } from "../../../assets/js/http-serve/http-methods";
import { mapGetters } from "vuex";
import ChangeAccount from "@/components/change-account";
export default {
  name: "bannerList",
  components: { ChangeAccount },
  data () {
    return {
      dingInfo: null,
      showChangeAccount: false, // 是否显示切换账号弹窗
      isInDingTalk,
      noticSearchText: '',
      bannerImgList: [],
      fileOperShow: fileOperShow,
      findHelpList: [],
      useSetMealList: [],
      userPointCnt: 0,
      remainCnt: 0,
      ddNoticList: [
        { title: '如何使用本地文件发起签约', val: '1' },
        { title: '如何使用模板发起签约', val: '2' },
        { title: '如何分配权限给成员', val: '3' },
        { title: '如何创建文件发起审批', val: '4' },
        { title: '如何将印章授权给成员使用', val: '5' },
        { title: '如何为印章关联审批', val: '6' },
      ],
      redBorder: false,
    }
  },
  mounted () {
    this.dingInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
  },
  computed: {
    ...mapGetters(["allAuthUser"]),
    loginUser () {
      return this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO
        : {};
    },
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
    noticeLengthCom () {
      if (isInDingTalk) {
        return true
      } else if (this.loginUser && this.allAuthUser.bindCorpUsers) {
        return this.loginUser.userType === 1 ? !!this.allAuthUser.bindCorpUsers.length : this.allAuthUser.bindCorpUsers.length > 1;
      } else {
        return false;
      }
    },
    // 获取拥有控制台权限的用户
    consoleUsers () {
      try {
        let users = this.$store.getters.allAuthUser.bindCorpUsers;
        let consoleUsers = [];
        // console.log(this.$store.getters.allAuthUser);
        if (this.$store.getters.allAuthUser.corpCreateFlag === 1) {
          // 超级管理员
          consoleUsers.push(this.$store.getters.allAuthUser.manCorpUser);
        }
        users.forEach(user => {
          if (user.perms && user.perms.length > 0) {
            consoleUsers.push(user);
          }
        });
        return consoleUsers;
      } catch (e) {
        return [];
      }
    },
    bindCorpUsersList () {
      return this.$store.getters.allAuthUser.bindCorpUsers;
    }
  },
}
</script>

<style scoped lang="less">
/deep/ .el-input--small .el-input__inner {
  border: none;
}
/deep/ .el-carousel__container {
  height: 176px;
}
.first_plate {
  height: 230px;
  background-color: #ffffff;
  padding: 30px 20px 0 20px;
  margin-bottom: 5px;
  .user_info {
    display: flex;
    justify-content: flex-start;
    .user_photo {
      width: 56px;
      height: 56px;
      flex-shrink: 0;
      margin-right: 15px;
      border-radius: 50%;
      cursor: pointer;
    }
    .user_msg {
      .name {
        font-size: 16px;
        font-weight: 500;
        color: #1d0000;
        cursor: pointer;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 300px;
      }
      .not_real_name {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .basis {
          background-color: rgba(236, 28, 28, 0.15);
          color: #ec1c1c;
          font-size: 12px;
          width: 80px;
          height: 20px;
          border-radius: 20px;
          line-height: 20px;
          text-align: center;
          cursor: pointer;
        }
        .senior {
          background-color: #f6e8d0;
          color: #ff8a00;
          font-size: 12px;
          width: 80px;
          height: 20px;
          border-radius: 20px;
          line-height: 20px;
          text-align: center;
          cursor: pointer;
        }
        .not_real_name_btn {
          width: 125px;
          padding: 3px;
          background: rgba(236, 28, 28, 0.15);
          border-radius: 14px;
          text-align: center;
          font-weight: 500;
          font-size: 13px;
          color: #ec1c1c;
          cursor: pointer;
          margin-right: 10px;
          &:hover {
            background-color: #ec1c1c;
            color: #ffffff;
          }
          .red_size {
            color: #ec1c1c;
          }
          .img {
            width: 16px;
            height: 16px;
            vertical-align: text-bottom;
            margin-right: 2px;
          }
          .icon {
            width: 10px;
            height: 10px;
            vertical-align: baseline;
            margin-left: 4px;
          }
        }
        .real_name {
          /*background: #C5FFFA;*/
          border-radius: 14px;
          font-weight: 500;
          font-size: 12px;
          /*color: #00D547;*/
          text-align: center;
          padding: 3px 8px 3px 0;
          margin-right: 10px;
          cursor: pointer;
          .img {
            width: 14px;
            height: 14px;
            vertical-align: text-bottom;
            margin-right: 2px;
          }
        }
      }
    }
  }
  .integral {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 30px 0 30px 0;
    .intergral_text {
      width: 165px;
      font-weight: 500;
      font-size: 12px;
      color: rgba(29, 0, 0, 0.75);
      .span {
        font-weight: 500;
        font-size: 16px;
        color: #1d0000;
      }
    }
    .detail {
      font-size: 12px;
      color: rgba(29, 0, 0, 0.45);
      cursor: pointer;
      &:hover {
        color: #ec1c1c;
        .active_more_icon {
          width: 10px;
          height: 10px;
          margin-left: 4px;
          flex-shrink: 0;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .active_more_icon {
        display: none;
      }
    }
  }
  .recharge_btn_box {
    display: flex;
    justify-content: space-between;
    position: relative;
    .change-account-sty {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 0 15px 1px rgba(236, 28, 28, 0.3);
      z-index: 1;
      position: absolute;
      top: 35px;
      right: 0;
    }
    .recharge_btn {
      width: 165px;
      padding: 4px 3px;
      border-radius: 100px 100px 100px 100px;
      // border: 1px solid #EC1C1C;
      text-align: center;
      color: #ec1c1c;
      background-color: rgba(236, 28, 28, 0.15);
      font-weight: 500;
      font-size: 13px;
      cursor: pointer;
      .recharge_icon {
        color: #ec1c1c;
        font-size: 16px;
      }
      &:hover {
        background: #ec1c1c;
        color: #ffffff;
        .recharge_icon {
          color: #ffffff;
        }
      }
    }
  }
}
.product_notice {
  background-color: #ffffff;
  .assets_system {
    height: 75px;
    display: flex;
    margin-bottom: 12px;
    justify-content: space-between;
    align-items: center;
    &.not_dingding {
      cursor: pointer;
      margin-bottom: 10px;
    }
    .imgs {
      max-height: 75px;
    }
    .recharge_btn1 {
      box-sizing: border-box;
      width: 165px;
      padding: 4px 3px;
      border-radius: 16px;
      // border: 1px solid #EC1C1C;
      text-align: center;
      color: #ec1c1c;
      background-color: rgba(236, 28, 28, 0.15);
      font-weight: 500;
      font-size: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background: #ec1c1c;
        color: #ffffff;
        .more_icon {
          display: none;
        }
        .no_more_icon {
          display: inline-block;
          width: 13px;
          height: 13px;
          vertical-align: middle;
        }
        .recharge_icon {
          color: #ffffff;
        }
      }
      .go_to {
        margin-right: 3px;
      }
      .no_more_icon {
        display: none;
      }
      .more_icon {
        width: 13px;
        height: 13px;
        vertical-align: middle;
      }
    }
  }
  .notice_content {
    &.big_ul_bottom {
      padding-top: 2px;
    }
    .notice_content_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 15px;
      .title {
        font-weight: bold;
        font-size: 14px;
        color: #1d0000;
        display: flex;
        align-items: center;
        .block {
          width: 4px;
          height: 14px;
          background: #1d0000;
          display: inline-block;
          margin-right: 15px;
        }
      }
      .more_see {
        cursor: pointer;
        font-size: 12px;
        color: rgba(29, 0, 0, 0.45);
        &:hover {
          color: #ec1c1c;
          .no_more_icon {
            display: none;
          }
          .more_icon {
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-left: 2px;
            flex-shrink: 0;
          }
        }
        .no_more_icon {
          width: 10px;
          height: 10px;
          margin-left: 2px;
          flex-shrink: 0;
        }
        .more_icon {
          display: none;
        }
      }
      .input-with-select {
        width: 220px;
        height: 30px;
      }
      .notice_search {
        width: 220px;
        display: flex;
        border: 1px solid #a0a0a0;
        border-radius: 30px;
        overflow: hidden;
        align-items: center;
        &:hover {
          border: 1px solid #626262;
        }
        &.red_border {
          border: 1px solid #ec1c1c;
        }
        .search_icon {
          width: 40px;
          text-align: center;
          cursor: pointer;
          border-left: 1px solid #a0a0a0;
          &:hover {
            color: #ec1c1e;
            font-weight: bold;
          }
        }
      }
    }
    .notice_list {
      padding: 0 20px 14px 20px;
      .notice_li {
        width: 100%;
        margin-top: 13px;
        &.big_top {
          margin-top: 16px;
        }
        &.ding_top {
          margin-top: 11px;
        }
        .inline_block {
          padding: 8px 15px 8px 10px;
          background: #f7fbf4;
          border-radius: 30px;
          font-size: 14px;
          color: #1d0000;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
            /*background: #e4f4d9;*/
            color: #ec1c1e;
          }
          .question_icon {
            max-width: 15px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .notice_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #1d0000;
      padding: 15px 0;
      display: flex;
      align-items: center;
      .block {
        width: 4px;
        height: 14px;
        background: #1d0000;
        display: inline-block;
        margin-right: 15px;
      }
    }
    .more_see {
      cursor: pointer;
      font-size: 12px;
      color: rgba(29, 0, 0, 0.45);
      &:hover {
        color: #ec1c1c;
        .no_more_icon {
          display: none;
        }
        .more_icon {
          display: inline-block;
          width: 10px;
          height: 10px;
          margin-left: 2px;
          flex-shrink: 0;
        }
      }
      .no_more_icon {
        width: 10px;
        height: 10px;
        margin-left: 2px;
        flex-shrink: 0;
      }
      .more_icon {
        display: none;
      }
    }
  }
}
.advertisement_box {
  background-color: #ffffff;
  margin-top: 5px;
  height: 176px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .banner-style {
    background-size: 100% 100%;
    width: 100%;
    height: 176px;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
    .img {
      width: 100%;
      height: 176px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/login/components/bannerList.vue